import { LayoutEnum } from '@goldcast/api/content';
import { getSpeakerLayoutBorderKey } from '@goldcast/utils';
import { LayoutChange } from '../types/RemotionPlayerConfigTypes/Segment/LayoutChange';
import { BaseConfig, layoutConfigMap } from '../types/speaker-types';

export const isLayoutAudiogram = (layout: LayoutEnum) => {
  return layout === 'AUDIOGRAM';
};

export const isLayoutDefault = (layout: LayoutEnum) => {
  return layout === 'DEFAULT';
};

export const isLayoutGrid = (layout: LayoutEnum) => {
  return layout === 'GRID';
};

export const isLayoutPip = (layout: LayoutEnum) => {
  return layout === 'PIP';
};

export const isLayoutActiveSpeaker = (layout: LayoutEnum) => {
  return layout === 'SPEAKER';
};

export const isLayoutFocus = (layout: LayoutEnum) => {
  return layout === 'FOCUS';
};

export const isSpeakerLayout = (layout: LayoutEnum) => {
  return !isLayoutAudiogram(layout) && !isLayoutDefault(layout);
};

export const getFinalConfigForLayout = (layout: LayoutChange | undefined, videosToShow: string[]): BaseConfig[] => {
  if (!layout) {
    return [];
  }
  if (isLayoutAudiogram(layout.layout)) {
    return [];
  }
  const config =
    layoutConfigMap[layout.size]?.[layout.layout]?.[layout.fitMode]?.[getSpeakerLayoutBorderKey(!layout.hideBorders)]?.[
      videosToShow.length
    ];
  if (config) {
    return config;
  }
  return [
    {
      style: { display: 'none' },
      containerStyle: { display: 'none' }
    }
  ];
};
